import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../services/account.service';

export const activeUserGuard: CanActivateFn = (route, state) => {
  const accountSvc = inject(AccountService);
  const router = inject(Router);

  if (accountSvc.userValue) {
    return true;
  }

  const url = router.createUrlTree(['/']);
  return url
};
